<template>
  <div class="theBackgroundColor" v-loading="loading">
    <div class="shareRankingBigBox">
      <div class="columnBackground">
        <img src="../assets/image/gongxiang_02.jpg" alt="" />
      </div>
      <div class="shareContent">
        <div class="sharedOnTheLeftSideOfThe">
          <div class="onTheLeftSideOfTheTitle">共享排行</div>
          <ul>
            <li>
              <span
                @click="indexOfTheReference((indexClick = 1))"
                :class="{ indexOfTheStyle: indexClick === 1 }"
                >人气指数</span
              ><span
                class=""
                :class="{ 'arrow-right': indexClick === 1 }"
              ></span>
            </li>
            <li>
              <span
                @click="shareIndex((indexClick = 2))"
                :class="{ indexOfTheStyle: indexClick === 2 }"
                >共享指数</span
              ><span
                class=""
                :class="{ 'arrow-right': indexClick === 2 }"
              ></span>
            </li>
            <li>
              <span
                @click="interactiveIndex((indexClick = 3))"
                :class="{ indexOfTheStyle: indexClick === 3 }"
                >互动指数</span
              ><span
                class=""
                :class="{ 'arrow-right': indexClick === 3 }"
              ></span>
            </li>
            <li>
              <span
                @click="attractIndex((indexClick = 4))"
                :class="{ indexOfTheStyle: indexClick === 4 }"
                >吸引指数</span
              ><span
                class=""
                :class="{ 'arrow-right': indexClick === 4 }"
              ></span>
            </li>
          </ul>
        </div>

        <div class="sharingOnTheRightSide">
          <div class="theRightSideOfTheTableFrame">
            <div class="switchOut">
              <ul>
                <li @click="clickOut(1)" :class="{ topStyle: msg === 1 }">
                  总排行
                </li>
                <li @click="clickOut(2)" :class="{ topStyle: msg === 2 }">
                  月排行
                </li>
              </ul>
            </div>

            <div class="inTopForm" v-show="msg === 1">
              <table>
                <tr>
                  <th>实验名称</th>
                  <th width="100px">负责人</th>
                  <th>所属学校</th>
                  <th width="100px">实验人次</th>
                </tr>
                <tr
                  v-for="(item, index) in tableData"
                  class="theExperimentTable"
                  :key="index"
                >
                  <td @click="clickOnTheCourse(item.id)">
                    <span class="theSerialNumber">{{ index + 1 }}</span>
                    <span class="theExperimentalImages" v-show="index < 3"
                      ><img
                        :src="theDefaultImage(item.cover)"
                        class="projectThePicture"
                        alt=""
                    /></span>
                    <span class="theName">{{
                      multipleLines(item.projectName)
                    }}</span>
                  </td>
                  <td>{{ headCount(item.projectLeader) }}</td>
                  <td>{{ item.schoolName }}</td>
                  <td>{{ item.num || 0 }}</td>
                </tr>
              </table>
            </div>

            <div class="inTopForm" v-show="msg === 2">
              <table>
                <tr>
                  <th>实验名称</th>
                  <th width="100px">负责人</th>
                  <th>所属学校</th>
                  <th width="100px">实验人次</th>
                </tr>
                <tr
                  v-for="(item, index) in tableData"
                  class="theExperimentTable"
                  :key="index"
                >
                  <td @click="clickOnTheCourse(item.id)">
                    <span class="theSerialNumber">{{ item.id }}</span>
                    <span class="theExperimentalImages" v-show="index < 3"
                      ><img
                        :src="theDefaultImage(item.cover)"
                        class="projectThePicture"
                        alt=""
                    /></span>
                    <span class="theName">{{
                      multipleLines(item.projectName)
                    }}</span>
                  </td>
                  <td>{{ headCount(item.projectLeader) }}</td>
                  <td>{{ item.schoolName }}</td>
                  <td>{{ item.num || 0 }}</td>
                </tr>
              </table>
            </div>

            <div class="turnThePage">
              <!-- <el-pagination
                background
                layout="prev, pager, next"
                :total="1000"
              >
              </el-pagination> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import {
  theSentimentIndex,
  sharedData,
  interactiveData,
  attractData,
} from "../assets/api/index";
import router from "../router/index.js";
import url from "../assets/js/config.js";
export default {
  setup() {
    const loading = ref(true);
    const indexRequest = reactive({
      orderType: 1,
    });
    const tableData = ref([]);

    //人气指数
    const rankingDataReference = reactive({
      orderType: 1,
    });

    //人气指数
    const indexOfTheReference = () => {
      tableData.value = [];
      theSentimentIndex(rankingDataReference).then((res) => {
        tableData.value = res.rows;
        loading.value = false;
      });
    };
    indexOfTheReference();

    //共享指数
    const shareIndex = () => {
      tableData.value = [];
      sharedData(rankingDataReference).then((res) => {
        tableData.value = res.rows;
        loading.value = false;
      });
    };

    //互动指数
    const interactiveIndex = () => {
      tableData.value = [];
      interactiveData(rankingDataReference).then((res) => {
        tableData.value = res.rows;
        loading.value = false;
      });
    };

    //吸引指数
    const attractIndex = () => {
      tableData.value = [];
      attractData(rankingDataReference).then((res) => {
        tableData.value = res.rows;
        loading.value = false;
      });
    };

    const msg = ref(1);
    const indexClick = ref(1);

    const theDefaultImage = (value) => {
      if (value == null) {
        return require("../assets/image/listmoren.jpg");
      } else {
        return url + value;
      }
    };
    //排行点击
    const clickOut = (value) => {
      msg.value = value;
      rankingDataReference.orderType = value;

      console.log(value);
      if (indexClick.value == 1) {
        indexOfTheReference();
      } else if (indexClick.value == 2) {
        shareIndex();
      } else if (indexClick.value == 3) {
        interactiveIndex();
      } else if (indexClick.value == 4) {
        attractIndex();
      }
    };
    //课程详情
    const clickOnTheCourse = (id) => {
      // localStorage.setItem("courseid", id);
      // router.push("/projectDetails");
         localStorage.setItem("tABWhich", 1);
      setTimeout(function () {
        location.reload();
      }, 50);

      localStorage.setItem("courseid", id);
      // router.push("/projectDetails");
        router.push({ path: 'projectDetails', query: { courseid: id }})
    };

    //多行
    const multipleLines = (value) => {
      return value.substr(0, 26);
    };

    const headCount = (value) => {
      return value.substr(0, 4);
    };

    //判断人数
    const determineTheNumberOf = (value) => {
      if (value == null) {
        return 0;
      }
    };
    return {
      // tableData,
      determineTheNumberOf,
      headCount,
      multipleLines,
      clickOut,
      theDefaultImage,
      rankingDataReference,
      msg,
      indexClick,
      tableData,
      url,
      clickOnTheCourse,
      loading,
      attractIndex,
      interactiveIndex,
      indexOfTheReference,
      shareIndex,
      indexRequest,
    };
  },

  name: "HelloWorld",
};
</script>

<style scoped>
.theBackgroundColor {
  background: #f4f4f4;
}
.columnBackground {
  text-align: center;
}
.shareContent {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 7px solid #fff;
  border-bottom: 7px solid #fff;
  border-left: 7px solid #a50c0d;
  display: inline-block;
  position: relative;
  left: 14px;
  top: 2px;
}
.sharedOnTheLeftSideOfThe {
  width: 216px;
  margin-right: 20px;
  position: relative;
  bottom: 64px;
}
.onTheLeftSideOfTheTitle {
  width: 216px;
  height: 60px;
  background: #a50c0d;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  text-align: center;
  font-size: 20px;
  line-height: 60px;
  color: #fff;
}
.sharedOnTheLeftSideOfThe ul li {
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #eee;
  text-align: center;
  cursor: pointer;
}
.sharedOnTheLeftSideOfThe ul {
  /*! border: 1px solid #eee; */
  background: #fff;
}
.sharingOnTheRightSide {
  width: 960px;
  min-height: 0;
  background: #fff;
  border-top: 2px solid #a50c0d;
  padding: 0 20px 0 20px;
  margin-top: 20px;
  max-height: 1226px;
  margin-bottom: 30px;
}
.switchOut {
  height: 55px;
  width: 100%;
  margin-top: 15px;
}
.switchOut ul li {
  width: 66px;
  height: 25px;
  float: left;
  padding: 5px;
  text-align: center;
  line-height: 25px;
  margin-left: 10px;
  border: 2px solid #a50c0d;
  font-size: 14px;
  color: #a50c0d;
  cursor: pointer;
}
.switchOut ul {
  float: right;
}
.inTopForm table tr th:nth-child(1) {
  text-align: start;
  text-indent: 38px;
}

.inTopForm table tr:nth-child(2),
.inTopForm table tr:nth-child(3),
.inTopForm table tr:nth-child(4) {
  color: red;
}

.inTopForm table tr td:nth-child(1) {
  text-align: start;
  text-indent: 38px;
}
.inTopForm table tr {
  height: 53px;
}
.inTopForm table tr th {
  background: #f7f8fa;
  border-right: 1px solid #eee;
  text-align: start;
  text-indent: 23px;
}
.inTopForm table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #eee;
}
.inTopForm tr {
  text-align: center;
}
.inTopForm tr td {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  text-align: start;
  text-indent: 25px;
}
.inTopForm table tr th {
  border-right: 1px solid #eee;
}
.topStyle {
  color: #fff !important;
  background: #a50c0d;
}
.theSerialNumber {
  line-height: 53px;
  width: 50px;
  margin-right: 29px;
}

.theExperimentalImages {
  position: relative;
  top: 13px;
  margin-right: 21px;
}
.turnThePage {
  height: 50px;
  margin-top: 30px;
  margin-bottom: 50px;
}
.indexOfTheStyle {
  color: #a50c0d;
}
.projectThePicture {
  width: 119px;
  height: 37px;
}
.theExperimentTable {
  cursor: pointer;
}
</style>